import React from "react";
import { Flex, Text, QueryLoader } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { ComplianceCaseEventType } from "~/graphql/supergraphEnums";
import { useGetComplianceCaseAuditLogsQuery } from "~/graphql/supergraphHooks";
import { formatShortFormDateInLocalTimezone } from "~/utils/datetime";
import * as styles from "./styles_vanilla.css";
import { getTextForEvent, isExternalComment, type ComplianceCaseAuditLog } from "./utils";
interface Props {
  caseId: number;
  showInternal: boolean;
}
const eventsToRender = ["case_created", "case_updated", "comment_added", "email_sent"];
const renderAuditLogCard = (auditLog: ComplianceCaseAuditLog) => (
  <Flex key={auditLog.id} flexDirection="column" className={styles.cardContainer}>
    <Text>{getTextForEvent(auditLog)}</Text>
    <Text variant="secondary-sm">{formatShortFormDateInLocalTimezone(auditLog.createdAt)}</Text>
    {auditLog.eventType === ComplianceCaseEventType.CommentAdded &&
      auditLog.eventData?.new?.comment_object_type === "case" && (
        <div
          className={
            isExternalComment(auditLog) ? styles.externalComment : styles.internalComment
          }
        >
          {auditLog.eventData?.new?.comment ?? ""}
        </div>
      )}
    <Icon
      className={styles.icon}
      type={
        auditLog.eventType === ComplianceCaseEventType.CommentAdded
          ? "circle-dot"
          : "check-circle"
      }
    />
  </Flex>
);
const CommentLogTracker: React.FC<Props> = ({ caseId, showInternal }: Props) => {
  // Fetch the audit logs for the case when the log tab loads.
  const complianceCaseAuditLogResult = useGetComplianceCaseAuditLogsQuery({
    variables: { caseId },

    fetchPolicy: "network-only",
  });
  const auditLogs = complianceCaseAuditLogResult.data?.getComplianceCaseAuditLogs ?? [];

  const visibleAuditLogs = auditLogs
    .filter((item) => eventsToRender.includes(item.eventType))
    .filter((item) => (showInternal ? !isExternalComment(item) : isExternalComment(item)))
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());

  return (
    <QueryLoader result={complianceCaseAuditLogResult}>
      <Flex
        flexDirection={"column"}
        flexGrow={1}
        gap={12}
        className={styles.logTimelineContainer}
      >
        {visibleAuditLogs.length === 0 ? (
          <Text variant="secondary-sm">
            {showInternal ? "No log entries yet." : "No external comments yet."}
          </Text>
        ) : (
          visibleAuditLogs.map(renderAuditLogCard)
        )}
      </Flex>
    </QueryLoader>
  );
};

export default CommentLogTracker;
